import { render, staticRenderFns } from "./ListCorrespondences.vue?vue&type=template&id=6cb164d1"
import script from "./ListCorrespondences.vue?vue&type=script&lang=js"
export * from "./ListCorrespondences.vue?vue&type=script&lang=js"
import style0 from "./ListCorrespondences.vue?vue&type=style&index=0&id=6cb164d1&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports